import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type BlogIconProps = CommonSvgProps

const BlogIcon: React.FC<BlogIconProps> = React.forwardRef<SVGSVGElement, BlogIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 34 33" {...props} ref={ref} color="none">
      <path d="M0 6.49976H33.3333V15.9015H0V6.49976Z" fill="#53A2D9" />
      <path d="M23.0771 20.1749H33.3336V32.1407H23.0771V20.1749Z" fill="#7BB835" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 21.0296C0 20.5576 0.3993 20.1749 0.891862 20.1749H19.621C20.1135 20.1749 20.5128 20.5576 20.5128 21.0296C20.5128 21.5017 20.1135 21.8843 19.621 21.8843H0.891862C0.3993 21.8843 0 21.5017 0 21.0296Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.22616C0 1.75412 0.396835 1.37146 0.886357 1.37146H11.0795C11.569 1.37146 11.9658 1.75412 11.9658 2.22616C11.9658 2.6982 11.569 3.08086 11.0795 3.08086H0.886357C0.396835 3.08086 0 2.6982 0 2.22616Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 26.1579C0 25.6859 0.3993 25.3032 0.891862 25.3032H19.621C20.1135 25.3032 20.5128 25.6859 20.5128 26.1579C20.5128 26.63 20.1135 27.0126 19.621 27.0126H0.891862C0.3993 27.0126 0 26.63 0 26.1579Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 31.286C0 30.8139 0.3993 30.4313 0.891862 30.4313H19.621C20.1135 30.4313 20.5128 30.8139 20.5128 31.286C20.5128 31.758 20.1135 32.1407 19.621 32.1407H0.891862C0.3993 32.1407 0 31.758 0 31.286Z"
        fill="#51565C"
      />
    </Svg>
  )
)

BlogIcon.propTypes = commonPropTypes
BlogIcon.defaultProps = commonDefaultProps

export default BlogIcon
